"use strict";

/**
 * transforms a object into an array
 * @param {object} collection
 * @returns {Array}
 */
export function sso_collection_as_array (collection) {
    let add = [], id;

    for (id in collection) {
        collection[id]['id'] = id;
        add.push(collection[id]);
    }

    return add;
}

/**
 * Smalll helper, to get phones for tel: links
 * @param {string} phone
 */
export function sanitize_phone (phone) {
    return phone.replace(/[^0-9+]/gi, '');
}


/**
 * Checks, weather a center can be displayed as private or not
 *
 * @param center
 * @returns {boolean}
 */
export function shown_location_as_exact (center) {

    // the easy case
    if (center.is_private || (center.location && center.location.type != '3')) {
        return false;
    }

    // alright, we have to check the addresses
    var addresses = sso_collection_as_array(center.addresses), i, addr;

    if (addresses && addresses.length) {
        for (i in addresses) {
            addr = addresses[i];
            if (addr.address_type === "meditation") {
                return addr.street_address && addr.city;
            }
        }
    }

    // default - we don't know
    return false;
}